import React, {useContext, useState} from "react";
import {Link} from "react-router-dom";
import {Col, Table} from "reactstrap";
import Select from "react-select";
import {AppContext} from "../../../App";
import {useLazyLoadQuery} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import _ from "lodash";
import {POWER_EDITORS} from "../../../utils/config";
import {getPopulatedUserGroups} from "../../../utils/cmpV2Utils";
import {PERMISSIONS, SERVICE_IDS} from "../../../utils/constants";

export const GetManageGroupsPermission = (tenantUuid, userAllPermissions) => {
  const { emailAddress } = useContext(AppContext).userProfile;
  if (POWER_EDITORS.includes(emailAddress)) return true;
  return userAllPermissions.some(item => {
    return item?.tenantUuid === tenantUuid && item?.roleCode === PERMISSIONS.MANAGE_GROUPS;
  });
};

const ListGroup = () => {
  const {userGroupsUserServiceInfo: userTenants, userAllPermissions,userProfile} = useContext(AppContext)

  const userId = userProfile?.auth0Id

  const alphabetizeLabels = (opt1, opt2) => opt1?.label.localeCompare(opt2?.label)
  let TenantOptions = _.isEmpty(userTenants) ? [] :
    userTenants.map(item => {
      const {services} = item?.groupDetails
      const serviceSet = new Set();

      services?.countries.forEach(item => {
        item?.services.forEach(service => {
          serviceSet.add(service?.serviceId)
        })
      })// value is tenantUuid
      return serviceSet.has(SERVICE_IDS.CMP) ? {label : item?.groupName, value : item?.groupUuid, groupUuid: item?.groupDetails?.userGroupUuid} : {}
    })
  TenantOptions = TenantOptions.filter(value => Object.keys(value).length !== 0).sort(alphabetizeLabels);

  const [selectedOption, setSelectedOption] = useState(TenantOptions.length > 0 ? TenantOptions[0] : null);

  const selectedTenantUuid = selectedOption?.value || "NO_SUCH_TENANT"
  const queryParams = `tenantUuid=${selectedTenantUuid}`
  const userGroupsAndTenantsQuery = `userId=${userId}&tenantUuid=${selectedTenantUuid}`

  const {groupsV2 = [], userGroupsV2 = []} = useLazyLoadQuery(
    graphql`
      query listGroupQuery($queryParams: String!, $userGroupsAndTenantsQuery: String!,$groupUuid : String! ) {
        userGroupsV2(userIds : $userGroupsAndTenantsQuery,tenantUuid: $groupUuid){
          groups
          email
          _tenantUuid
        }
        groupsV2 (tenantUuids: $queryParams, tenant: $groupUuid) {
          tenantUuid
          groups{
            uuid
            name
            userCount
            _audit{
              createdAt
            }
            status
          }
        }
      }
    `,
    {
      queryParams, userGroupsAndTenantsQuery, groupUuid: selectedTenantUuid
    }
  );

  const populatedUserGroups = getPopulatedUserGroups(userGroupsV2, groupsV2)

  const groups = POWER_EDITORS.includes(userProfile?.emailAddress) ? groupsV2 : populatedUserGroups
  const userManagePermission = userAllPermissions.some(item => {
    return item?.tenantUuid === selectedOption?.value && item?.roleCode === PERMISSIONS.MANAGE_USERS
  })
  let data = mapRows(groups.find(group => group?.tenantUuid === selectedOption?.value)?.groups,selectedOption?.value)



  function mapRows(rows,tenantUuid){
    return rows && rows.map(item => {
      const { uuid, name, userCount, _audit, status } = item ?? {};
      return (
        <tr key={uuid}>
          {GetManageGroupsPermission(selectedOption?.value,userAllPermissions) &&
          <td><Link to={{ pathname: "/app/v2/groups/edit" , state: {item,tenantUuid} }}>{name}</Link></td>}
          {GetManageGroupsPermission(selectedOption?.value,userAllPermissions) || <td>{name}</td>}
          {userManagePermission && <td><Link to={{pathname: `/app/usergroups/${selectedOption?.groupUuid}/users`, state:{groupsV2Uuid: uuid}}}>{userCount}</Link></td>}
          {userManagePermission || <td>{userCount}</td>}
          <td>{_audit?.createdAt ? new Date(_audit?.createdAt).toLocaleString() : ""}</td>
          <td>{status}</td>
        </tr>
      )
    })

  }


  return <div style={{margin : "50px"}}>
    <div className="d-flex">
      <Col sm={10}>
        {/*TODO:  multiSelect?*/}
        <Select
          className="form-select"
          options={TenantOptions}
          value={selectedOption}
          onChange={e => setSelectedOption(e)}
          placeholder={"select Tenant"}/>
      </Col>
      <Col sm={2}>
        { GetManageGroupsPermission(selectedOption?.value,userAllPermissions) && <Link to={{pathname: "/app/v2/groups/create-group"}} className="btn btn-outline-info" >Create Group</Link>}
      </Col>

    </div><br/>

    <Table striped>
      <thead style={{ color:"#2573a6"}}>
        <tr>
          <th>Name</th>
          <th>Users</th>
          <th>Created Date</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {data}
      </tbody>
    </Table>

  </div>

}


export default (props) => {
  return (
    <React.Suspense fallback={"Loading Groups..."}>
      <ListGroup {...props} />
    </React.Suspense>
  )
}
